var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"rank-table"},[_c('dv-scroll-board',{staticClass:"scroll-board",attrs:{"config":_vm.tableData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }